/* eslint-disable*/
/* global d3 $ _ */
/* eslint-disable-line */
//import "../../assets/lasso.css";
//import '../../vendor/chernoff.js';
import d3_lasso from "../../vendor/d3-lasso.js"
import "../../assets/lasso.css";
import pipeService from "../../service/pipeService";
import { zoomIdentity } from "d3";
let DrawScatterPlot = function(id){
    this.id = id
    this.divWidth = $('#' + this.id).width()
    this.divHeight = $('#' + this.id).height()
    this.margin = { top: 30, right: 20, bottom: 50, left: 20 }
    this.width = this.divWidth - this.margin.left - this.margin.right
    this.height = this.divHeight - this.margin.top - this.margin.bottom
    this.event_transform = d3.zoomIdentity;
    this.zoom = "";
}
DrawScatterPlot.prototype.reset_scale = function(){
    this.event_transform = d3.zoomIdentity;
    if(this.zoom){
        d3.select('#' + this.id)
        .call(this.zoom.transform, d3.zoomIdentity)
    }
    
}
DrawScatterPlot.prototype.layout = function(data, label, mode) {
    console.log("current mode", mode);

    // set the dimensions and margins of the graph
    var width = this.width,
    height = this.height;
    let filtered_data = data.filter(d=>{
            return d["selected_by_relation"];
        })
    // append the svg object to the body of the page
    d3.select("#"+this.id+"_svg").remove()
    var top_svg = d3.select("#"+this.id)
    .append("svg")
    .attr("id", this.id+"_svg")
    .attr("width", this.divWidth)
    .attr("height", this.divHeight)

    // var rect_width = Math.min(width, height);
    // var rect_height = rect_width;
    
    var rect_width = width;
    var rect_height = height;


    var svg = top_svg.append("g")
    .attr("transform",
        "translate(" + this.margin.left + "," + this.margin.top + ")");
    //console.log("d3", d3);
    //Read the data

    
    svg.append("clipPath").attr("id", this.id+"_clip-path")
    .append("rect").attr("width", rect_width).attr("height", rect_height)
    .attr("x", 0).attr("y", 0)

    let x_list = data.map((d)=>d.x);
    let y_list = data.map((d)=>d.y)
    var min_qs_2d_x = Math.min(...x_list);
    var max_qs_2d_x = Math.max(...x_list);
    var min_qs_2d_y = Math.min(...y_list);
    var max_qs_2d_y = Math.max(...y_list);

    // rect
    
    var x = d3.scaleLinear()
    .domain([min_qs_2d_x, max_qs_2d_x])
    .range([ 0, rect_width ]);
    //svg.append("g")
    //.attr("transform", "translate(0," + height + ")")
    //.call(d3.axisBottom(x));

    // Add Y axis
    var y = d3.scaleLinear()
    .domain([min_qs_2d_y, max_qs_2d_y])
    .range([ rect_height, 0]);
    //svg.append("g")
    //.call(d3.axisLeft(y));

    var x_scale = x;
    var y_scale = y
    
    let rect_obj = "";

    svg.append('rect')
    .attr("width", rect_width)
    .attr("height", rect_height)
    .attr("stroke", "#bbbbbb")
    .attr("stroke-width", 3)
    .attr("fill", function(d){
        rect_obj = this;
        return "#ffffff"
    })

    svg.append("text")
    .attr("x", rect_width / 2)
    .attr("y", -10)
    .attr("text-anchor","middle")
    .text(label);
    // Add dots
    let top_top_nodes = svg.append("g").style("clip-path", "url(#"+this.id+"_clip-path)");
    let top_nodes = top_top_nodes.append("g").classed("top_nodes", true)
    svg.selectAll("g.top_nodes").attr("transform", this.event_transform);
    let nodes = top_nodes.selectAll("g.nodes")
    .data(filtered_data, function(d, index) {
        return d.raw_question;
    });

    let node_enter = nodes.enter().append("g").classed("nodes", true);
    let node_enter_update = nodes.merge(node_enter);
    d3.selectAll("#"+label+"_projectionTooltip").remove();
    var hoverDiv = d3.select("body").append("div")
        .attr("class", "tooltip")
        .attr("id", label+"_projectionTooltip")
        .style("opacity", 0)
    let has_hovered = true;
    data.forEach(d=>{
        if(d.hovered){
            
            has_hovered = true;
            
        }
    })
    if(!has_hovered) {
        hideHoverTooltip();
    }
    let hovered_obj = "";
    function test_in_rect(hovered_obj, rect_obj){
        if(hovered_obj !== "" && rect_obj !== ""){
            let hovered_bounding_box = hovered_obj.getBoundingClientRect();
            let rect_bounding_box = rect_obj.getBoundingClientRect();
            let left = rect_bounding_box.x;
            let right = rect_bounding_box.width + left;
            let top = rect_bounding_box.y;
            let bottom = rect_bounding_box.height + rect_bounding_box.y;
            if(hovered_bounding_box.x >= left && hovered_bounding_box.x <= right){
                if(hovered_bounding_box.y >= top && hovered_bounding_box.y <= bottom){
                    return true;
                }
            }
            return false;
        }else{
            return true;
        }
    }
    function CheckHovered(){
        if(d3.event && hovered_obj !== ""){
            console.log("check in");
            let mouse_x = d3.event.pageX;
            let mouse_y = d3.event.pageY;
            let bounding_box = hovered_obj.getBoundingClientRect();
            let obj_x = bounding_box.x;
            let obj_y = bounding_box.y;
            let distance = (mouse_x-obj_x)*(mouse_x-obj_x) + (mouse_y-obj_y) * (mouse_y-obj_y);
            if(distance<0) distance=1e-8;
            distance = Math.sqrt(distance);
            if(distance >= 15){
                hideHoverTooltip();
                pipeService.emitHoverData(-1);
            }else{
                DisplayHoverTooltip(d, hovered_obj);
            }
        }else{

        }
    }
    function DisplayHoverTooltip(d, el){
        let html_text_1 = "Question Concept: " + d.info.question_concept + 
        "<br/>Question Stem: " + d.info.question_stem
        
        let html_text_2 =  "Target Concept: " + d.info.target_concept;
        let html_text = "";
        if(d.concept == "qs"){
            html_text = html_text_1;
        }else if(d.concept == "tc"){
            html_text = html_text_2;
        }
        let in_rect = test_in_rect(el, rect_obj);
        if(in_rect){
            let bounding_box = el.getBoundingClientRect();
            hoverDiv.style("opacity", ".7");
            hoverDiv.html(html_text)
                .style("left", (bounding_box.x - 105) + "px")
                .style("top", (bounding_box.y - 75) + "px");
        }

    }
    function hideHoverTooltip(){
        hoverDiv.style("opacity", 0);
    }
    function emitHover(index){
        if(mode == "lasso"){

        }else{
            pipeService.emitHoverData(index);

        }
    }

    node_enter.append("circle").classed("circlenodes", true)
    .attr("cx", function (d) { return x(d.x); } )
    .attr("cy", function (d) { return y(d.y); } )
    .attr("r", function(d) {
        let curr_r = 1.5;
        if(d.hovered){
            curr_r = 15;
            hovered_obj = this;
            DisplayHoverTooltip(d, hovered_obj);
        }
        else if(d.highlighted) curr_r = 10;
        
        return curr_r;
    })
    .style("opacity", function(d){
        if(d.highlighted){
            return 1;
        }else{
            return 0.7;
        }
    })
    .style("fill", function(d) {return d.color})
    .on('mouseover', function (d) {
        emitHover(d.index);
    })
    .on('mouseout', function (d, i) {
        hideHoverTooltip();
        emitHover(-1);
    })

    top_svg.on('mousemove', function (d) {
        // console.log("top_svg mousemove")
        CheckHovered();
    })


    ///// Handle Lasso
    /*node_enter_update    
        .attr("class", (d)=>(d.selected)?"lasso_selected":"lasso_unselected")*/
        node_enter_update
            .classed("lasso_selected", function(d) {return (d.selected)})
            .classed("lasso_unselected", function(d) { return (!d.selected)})






    var lasso_start = function() {
        lasso.items()
            .classed("lasso_not_possible", true)
            .classed("lasso_unselected", false)
            .classed("lasso_selected", false);
    };

    var lasso_draw = function() {

        // Style the possible dots
        lasso.possibleItems()
            .classed("lasso_not_possible", false)
            .classed("lasso_unselected", false)
            .classed("lasso_possible", true);

        // Style the not possible dot
        lasso.notPossibleItems()
            .classed("lasso_not_possible", true)
            .classed("lasso_unselected", false)
            .classed("lasso_possible", false);
    };
    //let onSelectedNodeListChange = this.onSelectedNodeListChange;
    var lasso_end = function() {
        // Reset the color of all dots
        lasso.items()
            .classed("lasso_not_possible", false)
            .classed("lasso_possible", false)
            .classed("lasso_unselected", true)

        // Style the selected dots
        lasso.selectedItems()
            .classed("lasso_selected", true)

        // Reset the style of the not selected dots

        let selectedItemsData = lasso.selectedItems().data();
        console.log("selectedItemsData", selectedItemsData);
        if (selectedItemsData.length == 0) {
            lasso.items()
                .classed("lasso_not_possible", false)
                .classed("lasso_possible", false)
                .classed("lasso_unselected", false)
                pipeService.emitSelectConcept(selectedItemsData);
        } else {
            // emit selected data
            pipeService.emitSelectConcept(selectedItemsData);
        }
    };
    var lasso = d3_lasso().closePathSelect(true)
        .closePathDistance(100)
        .items(node_enter_update)
        .targetArea(svg)
        .on("start", lasso_start)
        .on("draw", lasso_draw)
        .on("end", lasso_end);
    if(mode == "lasso"){
        svg.call(lasso);
    }

    




    ////////////////////////////////////////////////////////////////
    //////////////// Handle zoom-in & zoom-out
    ////////////////////////////////////////////////////////////////
    let _this = this;
    let mapwidth = width;
    let mapheight = height;
    let scaleExtent = 32;

      function transform(t) {
        return function(d) {
            let x = x_scale(d.x);
            let y = y_scale(d.y);
            let k = t.k;
            let maxk = 4;
            if(k>maxk) k = maxk;
            let coords = [x, y];
          return "translate(" + t.apply(coords) +")";
        };
      }
    if(mode == "zoom"){
        let zoom = d3
        .zoom()
        .scaleExtent([1, scaleExtent])
        .translateExtent([
            [-mapwidth * scaleExtent, -mapheight * scaleExtent],
            [mapwidth * scaleExtent, mapheight * scaleExtent]
        ])
        .on("zoom", function() {
            //console.log("transformed zoom", d3.event.transform)
            
            
            
            let transX = d3.event.transform.x,
            transY = d3.event.transform.y,
            transK = d3.event.transform.k
            // console.log("trans", d3.event.transform);
            // Way 1: Zoom all
            svg.selectAll("g.top_nodes").attr("transform", d3.event.transform);
            _this.event_transform = d3.event.transform;
            
            // Way 2: Have a max size of transK. Semantic Zooming
            /*
            let K = transK;
            if(K>4)K=4;
            node_enter_update.attr("transform", transform(d3.event.transform));
            node_enter_update.selectAll("circle").attr("r", function(d) {
                if(d.highlighted){
                    return 10*K;
                }else{
                    return 1.5*K;
                }
            })*/
            
        
        });
        this.zoom = zoom;
        d3.select('#' + _this.id)
        .call(zoom)
            
    }else{
        d3.select('#' + _this.id).on('.zoom', null);
        this.zoom = "";
    }
    
}

export default DrawScatterPlot;